import * as actions from './ActionTypes';
import ProbeService from '../services/ProbeService';

export const recordingProbeStarted = () => ({
  type: actions.RECORDING_PROBE_STARTED,
  startedAt: Date.now(),
});

export const recordingProbeFinished = () => ({
  type: actions.RECORDING_PROBE_FINISHED,
  finishedAt: Date.now(),
});

export const sendingProbesStarted = data => ({
  type: actions.SENDING_PROBES_STARTED,
  payload: {
    data,
  },
  sendingAt: Date.now(),
});

export const sendingProbesSuccess = () => ({
  type: actions.SENDING_PROBES_SUCCESS,
  receivedAt: Date.now(),
});

export const sendingProbesFailure = error => ({
  type: actions.SENDING_PROBES_FAILURE,
  error,
  receivedAt: Date.now(),
});

export const sendingProbes = () => (dispatch, getState) => {
  // Stop recording duration probe
  dispatch(recordingProbeFinished());

  // Get state
  const route = getState().router.location.pathname;
  const { service } = getState().generic.qs;
  const { lastAction, endTime, startTime } = getState().probes;
  const elapsed = endTime - startTime;

  // Add the probe
  ProbeService.addProbe({
    elapsed, route, lastAction, service,
  });

  // Send the probe
  dispatch(sendingProbesStarted(ProbeService.data));
  ProbeService.sendProbe().then(
    () => dispatch(sendingProbesSuccess()),
    err => dispatch(sendingProbesFailure(err.response)),
  );
};
